import React, {useEffect, useState} from "react";
import SimpleLineIcon from "react-simple-line-icons";
import "./Download.scss";
import 'toasted-notes/src/styles.css';
import {ConfigData} from "./DownloadServices";


function Download() {

    //states
    const [apk,setApk] = useState(null);
    const [bazar,setBazar] = useState(null);
    const [google,setGoogle] = useState(null);

    useEffect(()=>{
        getConfig().then();
    },[])


    const getConfig = async () =>{
        const config = await ConfigData();
        const digiMall = config.data.client_configs.find(item=>item.name==="digimaall");
        if(digiMall){
            setApk(digiMall.app_file)
            setBazar(digiMall.cafebazaar)
            setGoogle(digiMall.google_play)
        }
    }

    return(
        <div className="download-container">

            {/*Header*/}
            <div className="storeDetail-header">
                <img src="/other/logo.png" alt="logo"/>
            </div>

            <div className="download-container-jumb">
                <img src="/download/cell-phone.svg" alt=""/>
            </div>

            <div className="download-container-body">

                <h2>دیجمال نسخه ی پریمیوم</h2>
                <h4>پنجره ای نو به دنیای خریدنیها</h4>
                <p>برای استفاده از این قابلیت و سایر قابلیتهای ویژه ی دیجیمال باید نسخه ی پریمیوم آن را نصب کنید. این نسخه را میتوانید بصورت مستقیم، از کافه بازار و یا از گوگل پلی دانلود کنید.</p>

                <div className="btn-list">
                    <a href={apk}>
                        <img src="/download/android.png" alt=""/>
                    </a>
                </div>

                <div className="btn-list">
                    {/*<a href={bazar}>*/}
                    <a>
                        <img className="disabled-image-link" src="/download/cofeBazar.png" alt=""/>
                    </a>
                </div>

                <div className="btn-list">
                    <a>
                    {/*<a href={google}>*/}
                        <img className="disabled-image-link" src="/download/googlePlay.png" alt=""/>
                    </a>
                </div>

            </div>
        </div>
    )
}

export {Download}

